// eslint-disable-next-line import/no-extraneous-dependencies
import { makeStyles } from "tss-react/mui";
import InputBase from "@mui/material/InputBase";
import { styled } from "@mui/material/styles";

const useStyles = makeStyles()(() => ({
  search: {
    position: "relative",
    minHeight: "unset",
    border: "1px solid rgba(0, 0, 0, 0.05)",
    backgroundColor: "#f8fafc",
    width: "100%",
    height: "100%",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    padding: "0 12px",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:focus-within": {
      borderColor: "rgba(77, 18, 119, 0.3)",
      backgroundColor: "#ffffff",
      boxShadow: "0 4px 20px rgba(77, 18, 119, 0.08)",
    },
    "& svg": {
      color: "#94a3b8",
      fontSize: "20px",
      transition: "color 0.3s ease",
    },
    "&:focus-within svg": {
      color: "#4d1277",
    },
  },
  searchInputBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    width: "100%",
  },
  searchIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  closeIcon: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    marginLeft: "8px",
  },
}));
export default useStyles;

export const StyledInputBase = styled(InputBase)(() => ({
  color: "#334155",
  width: "100%",
  "& .MuiInputBase-input": {
    fontFamily: "Poppins",
    fontSize: "14px",
    height: "100%",
    width: "100%",
    padding: "8px 0",
    "::placeholder": {
      color: "#94a3b8",
      opacity: 1,
    },
  },
}));
